import { IntegrationServiceInstance } from '@/services/IntegrationsService'
import { formErrorsHandler } from '@/utils/formErrorsHandler'

export const Integrations = {
    namespaced: true,
    state: {
        show: {
            data: {},
            loading: false,
        },
    },
    mutations: {
        setData(state, obj) {
            Object.keys(obj).forEach((k) => (state.show.data[k] = obj[k]))
        },
        setShowLoading(state, bool) {
            state.show.loading = bool
        },
    },
    actions: {
        // *********************************************** //
        // ~ Dliza | Integration index, store, update, delete
        // *********************************************** //
        index(__, payload) {
            const { registry_id } = payload.params
            return IntegrationServiceInstance.index(registry_id, payload)
                .then((response) => response)
                .catch((error) => {
                    throw error
                })
        },
        store({ commit }, { payload }) {
            commit('setAppIsLoading', true, { root: true })
            const { registry_id } = payload
            return IntegrationServiceInstance.store(registry_id, payload)
                .then((res) => res)
                .catch((err) => {
                    throw formErrorsHandler(err)
                })
                .finally(() => {
                    commit('setAppIsLoading', false, { root: true })
                })
        },
        update({ commit }, { payload }) {
            commit('setAppIsLoading', true, { root: true })
            return IntegrationServiceInstance.update(payload.registry_id, payload.id, payload)
                .then((res) => res)
                .catch((err) => {
                    throw formErrorsHandler(err)
                })
                .finally(() => {
                    commit('setAppIsLoading', false, { root: true })
                })
        },
        show({ commit }, { id, registry_id }) {
            commit('setShowLoading', true)
            return IntegrationServiceInstance.show(registry_id, id)
                .then(({ data }) => {
                    const { integration } = data
                    commit('setData', {
                        ...integration,
                        mapping: Array.isArray(integration.mapping) ? integration.mapping : [],
                    })
                    return integration
                })
                .catch((err) => {
                    throw formErrorsHandler(err)
                })
                .finally(() => {
                    commit('setShowLoading', false)
                })
        },
        destroy({ commit }, { id = '', registry_id = '' }) {
            commit('setAppIsLoading', true, { root: true })
            return IntegrationServiceInstance.delete(registry_id, id)
                .then((res) => res)
                .catch((err) => {
                    throw formErrorsHandler(err)
                })
                .finally(() => {
                    commit('setAppIsLoading', false, { root: true })
                })
        },
    },
}